export default __webpack_public_path__ + "static/media/phone3.a35fca4f.svg";